import { render, staticRenderFns } from "./ManageTransfer.vue?vue&type=template&id=4c9e1d6b"
import script from "./ManageTransfer.vue?vue&type=script&lang=js"
export * from "./ManageTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports